import { USER_ROLES, type UserRole } from '@movo/contracts/domain/user';

const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Amministratore',
  fleet_manager: 'Fleet manager',
  user: 'Utente',
};

export type RoleOption = { value: UserRole; label: string };

export const ROLE_OPTIONS: RoleOption[] = USER_ROLES.map((value) => ({
  value,
  label: ROLE_LABELS[value],
}));

export function getRoleLabel(role: UserRole | undefined): string {
  return role ? ROLE_LABELS[role] : '';
}
